import React, { useState, useEffect } from 'react';
import Masonry from 'react-masonry-css';

import {
  IAssetWith5050TextFields,
  IMilestoneFields,
  IQuickStartGuideFields
} from '../../../types/contentful';

import { breakpoints } from '../../styles/media-queries';

import { QuickStartGuideBox } from '../QuickStartGuideBox';
import { BlockContainer, Layout, BoxColumn } from '../Layout';

import { ToggleWrapper, Toggle } from './styles';
import {
  MasonryWrapper,
  MASONRY_CLASS,
  MASONRY_COL_CLASS
} from '../MasonryWrapper';
import { Milestone } from '../Milestone';
import { AssetWith5050Text } from '../AssetWith5050Text';

function renderBeforeAfterComponent(
  component: IQuickStartGuideFields['afterImageWith5050text']
) {
  switch (component?.sys?.contentType?.sys?.id) {
    case 'assetWith5050Text':
      return (
        <AssetWith5050Text
          {...(component.fields as IAssetWith5050TextFields)}
        />
      );
    case 'milestone':
      return <Milestone {...(component.fields as IMilestoneFields)} />;
    default:
      return null;
  }
}

export function QuickStartGuide({
  beforeImageWith5050text,
  afterImageWith5050text,
  beforeBoxes,
  afterBoxes
}: IQuickStartGuideFields) {
  const [isMobile, setIsMobile] = useState(false);
  const [isAfter, setIsAfter] = useState(false);

  useEffect(() => {
    setIsMobile(
      typeof window !== `undefined` && window.innerWidth < breakpoints.tablet
    );
    setIsAfter(window.location.href.includes('after'));
  }, []);

  return (
    <>
      <BlockContainer
        marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
        marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
        data-blockid="quickStartGuideToggle"
      >
        <BoxColumn
          size={{ 0: 12, desktop: 10 }}
          paddingTop={{ 0: 0, desktop: 'xs' }}
        >
          <ToggleWrapper>
            <Toggle onClick={() => setIsAfter(false)} active={!isAfter}>
              <p>Set up your account</p>
            </Toggle>
            <Toggle onClick={() => setIsAfter(true)} active={isAfter}>
              <p>Set up your kids</p>
            </Toggle>
          </ToggleWrapper>
        </BoxColumn>
      </BlockContainer>
      {!isAfter ? (
        <>
          {renderBeforeAfterComponent(beforeImageWith5050text)}
          <BlockContainer
            marginTop={{
              0: 0,
              tablet: 'blockMarginY_tablet'
            }}
            marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
            data-blockid="beforeBoxes"
          >
            <Layout>
              <BoxColumn
                size={{ 0: 12, desktop: 10 }}
                paddingTop={{ 0: 0, desktop: 'xs' }}
              >
                {isMobile &&
                  (beforeBoxes || []).map(({ sys, fields }) => (
                    <QuickStartGuideBox {...fields} key={sys?.id} />
                  ))}
                {!isMobile && (
                  <MasonryWrapper>
                    <Masonry
                      breakpointCols={2}
                      className={MASONRY_CLASS}
                      columnClassName={MASONRY_COL_CLASS}
                    >
                      {(beforeBoxes || []).map(({ sys, fields }) => (
                        <QuickStartGuideBox {...fields} key={sys?.id} />
                      ))}
                    </Masonry>
                  </MasonryWrapper>
                )}
              </BoxColumn>
            </Layout>
          </BlockContainer>
        </>
      ) : (
        <>
          {renderBeforeAfterComponent(afterImageWith5050text)}
          <BlockContainer
            marginTop={{
              0: 0,
              tablet: 'blockMarginY_tablet'
            }}
            marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
            data-blockid="afterBoxes"
          >
            <Layout>
              <BoxColumn
                size={{ 0: 12, desktop: 10 }}
                paddingTop={{ 0: 0, desktop: 'xs' }}
              >
                {isMobile &&
                  (afterBoxes || []).map(({ sys, fields }) => (
                    <QuickStartGuideBox {...fields} key={sys?.id} />
                  ))}
                {!isMobile && (
                  <MasonryWrapper>
                    <Masonry
                      breakpointCols={2}
                      className={MASONRY_CLASS}
                      columnClassName={MASONRY_COL_CLASS}
                    >
                      {(afterBoxes || []).map(({ sys, fields }) => (
                        <QuickStartGuideBox {...fields} key={sys?.id} />
                      ))}
                    </Masonry>
                  </MasonryWrapper>
                )}
              </BoxColumn>
            </Layout>
          </BlockContainer>
        </>
      )}
    </>
  );
}
